












































import { Component, Vue, Prop } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";

@Component({
  components: {}
})
export default class ModalRekonsiliasiAdmisi extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() err!: object;
  @Prop() sess_login!: object;
  @Prop() dataRekon!: [];

  mounted() {}

  get headers() {
    return [
      { text: "No", value: "index", width: "10px" },
      { text: "Nama Obat", value: "nama_obat", width: "150px" },
      {
        text: "Regimen Sebelumnya",
        value: "regimen_text",
        width: "150px"
      },
      { text: "Obat Dibawa", value: "obat_dibawa", width: "100px" },
      { text: "Obat Dilanjut", value: "obat_lanjut", width: "100px" },
      {
        text: "Regimen Selama Rawat Inap",
        value: "regimen_ranap_text",
        width: "150px"
      }
    ];
  }

  get storeUser() {
    return userModule.user;
  }

  get dialog() {
    return this.value;
  }

  set dialog(value) {
    this.$emit("input", value);
  }

  close() {
    this.dialog = false;
  }
}
